import { mapLocaleToLanguage } from './LocaleHelper';

/**
 * Generates a URL for the agency grievance portal based on current environment
 * Uses the agencyName value from sessionStorage set by ROMP API call
 * @param stage - The deployment stage (beta-eu, gamma-eu, prod-eu)
 * @param agencyName - The agency name from session storage
 * @param locale - The current locale to determine the language parameter
 * @returns The complete URL for the agency grievance portal
 */
export function getAgencyUrl(stage: string, agencyName: string, locale?: string): string {
  let baseUrl: string;

  switch (stage) {
    case 'beta-eu':
      baseUrl = 'https://gamma-mena.fra.chat.warehousejobs.in';
      break;
    case 'gamma-eu':
      baseUrl = 'https://preprod-mena.fra.chat.warehousejobs.in';
      break;
    case 'prod-eu':
      baseUrl = 'https://mena.fra.chat.warehousejobs.in';
      break;
    default:
      throw new Error(`Unknown environment: ${stage}`);
  }

  // TODO: Use language variable in prod when releasing the Hindi language support
  const language = stage === 'prod-eu' ? 'English' : mapLocaleToLanguage(locale || '');

  if (!agencyName) {
    return `${baseUrl}/?language=${language}&country=India&type=Agency%20Hiring&ingressPoint=PHO`;
  }

  return `${baseUrl}/?language=${language}&country=India&type=Agency%20Hiring&ingressPoint=PHO&agency=${encodeURIComponent(agencyName)}`;
}
